const selectIncidents = (state) => state.incidents;
export default selectIncidents;
